import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Badge, Row, Col, Tab, Nav } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker from "react-multi-date-picker";
import ReWorkView from '../../../modal/Production_Management/Manage_Daily_Order/ReWorkView';
import axios from 'axios';
import uthappam from '../../../../images/items/podi_uthappam.png';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const Daily_Orders = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [slectedDate, setSelDate] = useState(new Date());
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [key, setKey] = useState('rework');
    const [selectedData, setselData] = useState({});
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const tableRef = useRef(null);

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const fetchData = (date = slectedDate) => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }

        const params = {
            rework_date: formatDate(date),
            branch_id: branch_id,
        };

        axios.get(`${baseURL}/rework_list`, { params })
            .then(res => {
                setData(res.data.data || []);
                setHasFetched(true);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setData([]);
                setHasFetched(true);
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (hasFetched && tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    responsive: true,
                    ordering: false,
                    language: { lengthMenu: "Show _MENU_" },
                    dom:
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, [hasFetched]);

    const onInit = () => {};

    const handleNeededReWorkView = (data) => {
        setModalType("ReWorkView");
        setselData(data);
        setOpen(true);
    };

const formatNumber = (num) => {
  if (num === null || num === undefined) return "";
  return parseFloat(num).toString();
};
const formatTime = (time) => {
    if (!time) return "-";

    let [hour, minute] = time.split(":");
    hour = parseInt(hour, 10);

    const ampm = hour >= 12 ? "pm" : "am";
    const hour12 = hour % 12 || 12;

    return `${hour12}:${minute} ${ampm}`;
};


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles flex-wrap px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Daily Orders</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>
                </div>

                {open && modalType === "ReWorkView" && (
                    <ReWorkView show={open} onClose={() => setOpen(false)} data={selectedData} />
                )}
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={setKey}>
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/manage-daily-orders">
                                    <i className="fa-solid fa-bowl-food px-2"></i>
                                    <label className="fs-6">Today's Item</label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link eventKey="rework">
                                    <i className="fa-solid fa-person-walking-arrow-loop-left px-2"></i>
                                    <label className="fs-6">Rework</label>
                                </Nav.Link>
                            </Nav.Item>

                          
                        
                       

                        </Nav>

                          <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap">
                                        <div className='datepicker-wrapper d-flex'>
                                          <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                          {/* <DatePicker value={slectedDate} format="DD-MM-YYYY" placeholder='Select Date' onChange={(date) => setSelDate(date ? date.toDate() : null)} onClick={softRefresh}/> */}
                                            <DatePicker
                                            value={slectedDate}
                                            format="DD-MM-YYYY"
                                            placeholder='Select Date'
                                            onChange={(date) => {
                                                if (date) {
                                                    const jsDate = date.toDate();
                                                    setSelDate(jsDate);
                                                    fetchData(jsDate);
                                                } else {
                                                    setSelDate(null);
                                                    setData([]);
                                                }
                                            }}
                                        />
                        
                        
                                        </div>
                                        {/* <Button className="me-2 btn-sm" variant="primary" onClick={softRefresh}><span className='font-w400'>Submit</span></Button> */}
                                      </div>

                                             </div>
                     

                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="rework">
                                <Row className='mb-4'>
                                   
                                </Row>

                                <Row>
                                    <div className='col-lg-12 mb-2'>
                                        <table ref={tableRef} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                            <thead>
                                                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className='min-w-100px'>Item</th>
                                                    <th className='min-w-50px'>Reworked Quantity</th>
                                                    <th className='min-w-50px text-center'>Rework Start/End Time</th>
                                                    <th className='min-w-250px text-center'>Reason</th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-gray-600 fw-semibold fs-7">
                                                {datas.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className='d-flex align-items-center justify-content-start gap-2'>
                                                                <LightGallery
                                                                    onInit={onInit}
                                                                    speed={500}
                                                                    plugins={[lgThumbnail, lgZoom]}
                                                                >
                                                                    <div data-src={data.item_image || uthappam} className='border rounded px-1 py-0'>
                                                                        <img src={data.item_image || uthappam} alt={data.item_name} className='cursor-pointer w-50px h-50px' />
                                                                    </div>
                                                                </LightGallery>
                                                                <div className='d-flex flex-column align-items-start'>
                                                                    <label className='text-black font-w500 fs-7'>{data.item_name}</label>
                                                                    <label className='text-primary font-w500 fs-7'>{data.schedule_name}</label>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <Badge bg="danger" className='py-1 px-2 fs-7'>
                                                                {formatNumber(data.rework_qty)} {data.unit_name} 
                                                            </Badge>
                                                        </td>

                                                        <td className='text-center'>
                                                            <label className='text-black font-w500 fs-7'>
                                                                {formatTime(data.rework_start_time)} | {formatTime(data.rework_end_time)}
                                                            </label>
                                                        </td>

                                                        <td className='text-end'>
                                                            <label className='text-black font-w500 fs-7 text-wrap text-justify scroll-y mh-80px'>
                                                                {data.rework_reason || '-'}
                                                            </label>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    );
};

export default Daily_Orders;
